import ReportPage from './ReportPage'

export default function CadastroVendedorReport({className = ''}: {className?: string}) {
  return <ReportPage type='vendedor_distribuidor' className={className} />
}
